<template>
  <div class="mt-5 pb-5">
    <h1 class="fw-normal my-3 text-center">Datos del restaurante</h1>
    <form id="formulario" class="bg-white p-3 p-sm-5 rounded-5">
      <div class="form-group mb-5">
        <label for="restaurantName">Nombre del restaurante:<span class="text-danger">*</span></label>
        <input type="text" class="form-control w-md-75 shadow ml-2 my-2" id="restaurantName" v-model="restaurantName" maxlength="100"/>
      </div>
      <div class="mb-4">
        <label>
          Plan del restaurante:
          <span class="fw-bold ms-2">
            <span v-if="ewu_profesional">EWU PROFESIONAL</span>
            <span v-else>EWU BÁSICO</span>
          </span> 
        </label>
      </div>
      <div class="form-group mb-3 ">
        <label for="address" class="mb-2">Ubicación del restaurante:</label>
        <!--<input type="text" class="form-control w-75 shadow ml-2 mt-3" id="address" v-model="address" placeholder="Ej: Calle Santa Fe, 2, Alicante, 03002"/>
        -->
        <address-browser-component @getDataBrowser="getDataBrowser" :address="address" :longitud="longitud" :latitud="latitud" class="shadow ml-2 mt-3"></address-browser-component>
        <!--<p>{{ this.latitud }}</p>
        <p>{{ this.longitud }}</p>-->
        <div class="form-check mt-2 ml-2" v-if="ewu_profesional">
          <input class="form-check-input" type="checkbox" id="required_location" v-model="required_location"/>
          <label class="form-check-label" for="required_location">
            Comprobar la ubicación del comensal para verificar si está en el restaurante
          </label>
        </div>
      </div>
      <h3 class="mt-5 mb-3">Configuración del restaurante</h3>
      <div class="form-group mt-4">
        <span class="fs-5 mb-3">Personalización visual</span>

        <div class="row ml-2">
          <div class="col-12 col-md-6 my-3">
            <label for="primaryColor" class="form-label d-flex align-items-center gap-2">
              Color primario:
              <div class="d-flex align-items-center gap-3">
                <input type="color" id="primaryColor" v-model="primary_color" class="form-control-color shadow p-0 border-0" style="width: 2rem; height: 2rem; cursor: pointer;"/>
                <button type="button" class="btn btn-sm btn-outline-secondary rounded-3" @click="resetPrimaryColor">Resetear color</button>
              </div>
            </label>
          </div>
          <!--
            <div class="col-6 col-md-4 mb-3">
              <label for="secondaryColor">Color secundario:</label>
              <input type="color" id="secondaryColor" v-model="secondary_color" class="form-control form-control-color shadow w-100 w-md-50" />
            </div>
          -->
          <div class="mb-3">
            <label for="restaurantLogo">Logo del restaurante:</label>
            <input type="file" id="restaurantLogo" @change="handleLogoUpload" accept="image/*" class="form-control shadow w-100" />
            <div v-if="logoPreview" class="mt-3">
              <label class="mb-2">Previsualización:</label><br />
              <img :src="logoPreview" alt="Previsualización del logo" style="max-height: 100px;" class="rounded shadow" />
              <button type="button" class="btn btn-sm btn-outline-secondary mt-2 ml-5 rounded-3" @click="removeLogo">
                Quitar imagen
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--
        <div class="form-group mb-4">
          <label for="tableTime" class="form-label">
            Tiempo activo de la mesa (minutos):<span class="text-danger">*</span>
          </label>
          <div class="d-flex align-items-center">
            <input type="number" v-model="tableTime" class="form-control text-center" id="tableTime" min="0" style="width: 80px;" />
            <button class="btn btn-outline-secondary mx-2" @click.prevent="decreaseTableTime">-</button>
            <button class="btn btn-outline-secondary" @click.prevent="increaseTableTime">+</button>
          </div>
        </div>
      -->
      <div class="form-group mt-4" v-if="ewu_profesional">
        <span class="fs-5 mb-3">Horario de cocina</span>
        <div class="row">
          <div v-for="(schedule, index) in schedules" :key="index" class="col-12 mb-3 d-flex">
            <div class="card h-100 w-100 position-relative shadow-sm">
              <button v-if="schedules.length > 1 && index > 0" class="btn btn-md position-absolute top-0 end-0 m-2" style="color: var(--primary-color);" @click.prevent="removeSechedule(index)">
                <i class="bi bi-x"></i>
              </button>
              <div class=" d-flex flex-column h-auto p-3">
                <div class="row flex-grow-1 align-items-center">
                  <div class="col-12 col-sm-auto d-flex flex-wrap justify-content-start align-items-center mb-2 mb-sm-0">
                    <span class="mx-2 mb-2">Hora de apertura</span>
                    <input type="time" class="form-control mx-2 text-center time-input w-100 w-sm-auto" v-model="schedule.inicio"/>
                    <span class="mx-2 mt-4 mb-2">Hora de cierre</span>
                    <input type="time" class="form-control mx-2 text-center time-input w-100 w-sm-auto" v-model="schedule.fin"/>
                  </div>
                  <div class="col-12 col-sm d-flex flex-wrap mb-2 mb-sm-0">
                    <label v-for="(day, dIndex) in days" :key="dIndex" class="form-check-label mr-3 d-flex align-items-center">
                      <input type="checkbox" class="form-check-input m-1" :value="day" v-model="schedule.selectedDays"/>
                      {{ day }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-check mt-5 ml-2">
            <label class="form-check-label" for="has_delivery">Envío a domicilio</label>
            <input class="form-check-input" type="checkbox" id="has_delivery" v-model="hasDelivery" @change="toggleDelivery"/>
          </div>
          <div v-if="hasDelivery" class="mt-2 ml-4 mb-4">
            <label for="delivery_radius" class="form-label">Radio máximo permitido para delivery (kms):</label>
            <input type="number" class="form-control w-25" id="delivery_radius" v-model="max_km_delivery" placeholder="Ingrese el radio en kilómetros" min="1"/>
          </div>
        </div>
      </div>
      <div class="form-group mt-4" v-if="ewu_profesional">
        <div class="row">
          <div class="form-check mt-2 mb-5 ml-2">
            <label class="form-check-label" for="user_allowed_to_cancel_order">Permitir que el cliente pueda cancelar delivery y take away</label>
            <input class="form-check-input" type="checkbox" id="user_allowed_to_cancel_order" v-model="user_allowed_to_cancel_order"/>
          </div>
        </div>
      </div>
      <div class="form-group mb-5 d-flex flex-wrap flex-md-nowrap">
        <div class="w-100 w-md-50 mr-3">
          <label for="tpvs_select" class="my-2">TPV:</label>
          <select id="tpvs_select" class="form-select shadow ml-2" v-model="selectedTpvId">
            <option value="">Sin TPV informado</option>
            <option v-for="tpvItem in tpvsList" :key="tpvItem.id" :value="tpvItem.id">
              {{ tpvItem.name }}
            </option>
          </select>
          <FormEasyPosComponent
            v-if="selectedTpvName === 'EasyPos'"
            :organizationId="organizationId"
            :puntoVentaId="puntoVentaId"
            @update:organizationId="val => organizationId = val"
            @update:puntoVentaId="val => puntoVentaId = val"
          />
          <FormBDPComponent
            v-else-if="selectedTpvName === 'BDP'"
            :login="login"
            :password="password"
            :integratorCode="integratorCode"
            :localUrl="localUrl"
            @update:login="val => login = val"
            @update:password="val => password = val"
            @update:integratorCode="val => integratorCode = val"
            @update:localUrl="val => localUrl = val"
          />
          <FormRevoComponent
            v-else-if="selectedTpvName === 'Revo'"
            :token="revoToken"
            :accountUsername="revoAccountUsername"
            :clientToken="revoClientToken"
            @update:token="val => revoToken = val"
            @update:accountUsername="val => revoAccountUsername = val"
            @update:clientToken="val => revoClientToken = val"
          />
          <FormLastAppComponent
            v-else-if="selectedTpvName === 'LastApp'"
            :token="lastappToken"
            :locationId="lastappLocationId"
            :catalogId="lastappCatalogId"
            :brandId="lastappBrandId"
            @update:token="val => lastappToken = val"
            @update:locationId="val => lastappLocationId = val"
            @update:catalogId="val => lastappCatalogId = val"
            @update:brandId="val => lastappBrandId = val"
          />
          <FormEposNowComponent
            v-else-if="selectedTpvName === 'EposNow'"
            :token="eposnowToken"
            @update:token="val => eposnowToken = val"
          />
        </div>
      </div>

      <!-- PARTE DE LA FORMA DE PAGO
        <div class="form-group mb-3">
          <label class="d-block">Forma de pago:<span class="text-danger">*</span></label>
          <div class="form-check">
            <input class="form-check-input custom-radio" type="radio" name="payOption" id="pagoCadaPedido" value="pagoCadaPedido"/>
            <label class="form-check-label" for="pagoCadaPedido">
              Pago en cada pedido
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input custom-radio" type="radio" name="payOption" id="pagoAlFinal" value="pagoAlFinal" v-model="payOption"/>
            <label class="form-check-label" for="pagoAlFinal">
              Pago al final
            </label>
          </div>
        </div>
      -->
      <div v-if="ewu_profesional">
        <div class="form-group mb-3">
          <div class="d-flex align-items-center">
            <label class="d-block me-2">Modo Avanzado</label>
            <div class="form-check form-switch">
              <input class="form-check-input custom-slider" style="width:50px" type="checkbox" id="advanceMode" v-model="advanceMode"/>
              <label class="form-check-label" for="advanceMode"></label>
            </div>
          </div>
          <small class="text-muted">
            El modo Avanzado de Eat with us te permite crear modos de uso de la plataforma adaptados a tu restaurante.
          </small>
        </div>
      </div>
      <div v-if="advanceMode" id="modes-list">
        <div class="d-flex overflow-x-auto custom-scroll">
          <div v-for="mode in modes" :key="mode.id" class="card text-center p-3 mx-2 mb-2 rounded-5 shadow" style="min-width: 230px; max-width: 220px; height: 130px; border: 1px solid #eee; background-color: #f7f7f7; overflow: hidden;">
            <div class="d-flex flex-column g-0" style="height: 100%; width: 100%;">
              <div class="col d-flex flex-column justify-content-center p-2 mt-2">
                <div class="p-0">
                  <h3 class="mb-4" style="font-size: 1.2rem; text-align: center; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ mode.name }}
                  </h3>
                  <div class="card-actions mt-2 d-flex align-items-center justify-content-center">
                    <i class="fa-solid fa-pencil mr-2 action-icon" @click="openEditModeModal(mode)" style="color: var(--primary-color);"></i>
                    <i class="fa-regular fa-trash-can action-icon" @click="openDeleteModeModal(mode)" style="color: var(--primary-color);"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <button type="button" @click="openModalNewMode" class="btn btn-outline-secondary">Crear Modo</button>
        </div>
      </div>
      <div v-if="errorMessage" class="alert alert-danger mt-3">{{ errorMessage }}</div>
      <div class="d-flex align-items-center justify-content-center mt-3">
        <button type="button" class="btn btn-secondary" @click="TPV_confirmation()">Guardar</button>
      </div>
    </form>
    <!-- POPUP CONFIRMACIÓN/ERROR PARA ORDENADOR (ABAJO DELECHA) -->
    <div v-if="showConfirmation" class="position-fixed bottom-0 end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 1000;">
      <h6 class="mt-2"><i class="fa-solid fa-circle-check text-success"></i> Configuración actualizada con éxito</h6>
    </div>
    <div v-if="showError" class="position-fixed bottom-0 end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 1000;">
      <h6 class="mt-2"><i class="fa-solid fa-circle-xmark text-danger"></i> No se ha podido actualizar la configuración</h6>
    </div>

    <!-- POPUP CONFIRMACIÓN/ERROR PARA MOVIL (ALIBA CENTLO) -->
    <div v-if="showConfirmation" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(139, 139, 139, 0.5); z-index: 1000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2"><i class="fa-solid fa-circle-check text-success"></i> Configuración actualizada con éxito</h6>
      </div>
    </div>
    <div v-if="showError" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(139, 139, 139, 0.5); z-index: 1000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2"><i class="fa-solid fa-circle-xmark text-danger"></i> No se ha podido actualizar la configuración</h6>
      </div>
    </div>
    <NewModeModalComponent
      :isOpen="showAddMode" 
      @close="closeAddModeModal" 
      @guardar="addMode"
    />
    <EditModeModalComponent
      :isOpen="showEditMode" 
      :modoData="selectedMode"
      @close="closeEditModeModal" 
      @actualizar="updateMode"
    />
    <DeleteModeModalComponent
      :showModal="showDeleteMode"
      :mode="selectedMode"
      @close="closeDeleteModeModal"
      @confirm-delete="deleteMode"
    />
    <tpv-confirmation-modal
      :isOpen="showTpvModal"
      @close="showTpvModal = false"
      @confirm="onTpvConfirm"
    />
    <SpinnerComponent id="spinner"></SpinnerComponent>
  </div>
</template>

<script>
  import NewModeModalComponent from '@/components/NewModeModalComponent.vue';
  import EditModeModalComponent from '@/components/EditModeModalComponent.vue';
  import DeleteModeModalComponent from '@/components/DeleteModeModalComponent.vue';
  import AddressBrowserComponent from '@/components/AddressBrowserComponent.vue';
  import SpinnerComponent from '../components/SpinnerComponent.vue';
  import TpvConfirmationModal from '@/components/TpvConfirmationModal.vue';

  import FormEasyPosComponent from '@/components/FormEasyPosComponent.vue';
  import FormBDPComponent from '@/components/FormBDPComponent.vue';
  import FormRevoComponent from '@/components/FormRevoComponent.vue';
  import FormLastAppComponent from '@/components/FormLastAppComponent.vue';
  import FormEposNowComponent from '@/components/FormEposNowComponent.vue';


  import axios from 'axios';
  import { mapState } from 'vuex';
  import { v4 as uuidv4 } from 'uuid';

  export default {
    components: {
      NewModeModalComponent,
      EditModeModalComponent,
      DeleteModeModalComponent,
      AddressBrowserComponent,
      TpvConfirmationModal,
      SpinnerComponent,
      FormEasyPosComponent,
      FormBDPComponent,
      FormRevoComponent,
      FormLastAppComponent,
      FormEposNowComponent
    },
    data() {
      return {
        restaurantName: '',
        address: '',
        required_location: false,
        tableTime: 120,
        days: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
        schedules: [],
        tpvsList: [],
        tpv_id: '',
        selectedTpvId: '',
        advanceMode: false,
        modes: [],
        selectedMode: null,
        editingMode: null,
        showAddMode: false,
        showEditMode: false,
        showDeleteMode: false,
        showConfirmation: false,
        showError: false,
        errorMessage: '',
        latitud: null,
        longitud: null,
        first_charge:true,
        max_km_delivery: null,
        hasDelivery: false,
        user_allowed_to_cancel_order: false,
        showTpvModal: false,
        // CAMPOS EASYPOS
        organizationId: '',
        puntoVentaId: '',
        // CAMPOS BDP
        login: '',
        password: '',
        integratorCode: '',
        localUrl: '',
        // CAMPOS REVO
        revoToken: '',
        revoAccountUsername: '',
        revoClientToken: '',
        // CAMPOS LASTAPP
        lastappToken: '',
        lastappLocationId: '',
        lastappCatalogId: '',
        lastappBrandId: '',
        // CAMPOS EPOSNOW
        eposnowToken: '',
        // APARTADO PERSONALIZACIÓN
        primary_color: "#ff6600",
        secondary_color: "#333399",
        logoPreview: null,
      };
    },
    props: {
        ewu_profesional: { type: Boolean }
    },
    watch: {
      schedules: {
        handler(newSchedules) {
          const last = newSchedules[newSchedules.length - 1];
          // Cuando el último tenga ambos campos rellenos, añadimos uno vacío
          if (last.inicio && last.fin) {
            this.addSchedule();
          }
        },
        deep: true
      }
    },
    methods: {
      getDataBrowser(direccion, coords){
        this.address = direccion
        console.log(direccion)
        console.log(coords)
        this.latitud = String(coords[1])
        this.longitud = String(coords[0])
      },
      async loadRestaurantConfig() {
        const url = process.env.VUE_APP_API_URL+'/v1/api/partner/get_restaurant_config';
        try {
          const response = await axios.get(url, {
            headers: {
              'Authorization': `Bearer ${this.partner_token}`,
            }
          });

          const data = response.data;
          this.restaurantName = data.name || '';
          this.address = data.address || '';
          // Ñapilla de coordenadas pq es un poco caos, no tocar, VA BIEN
          this.latitud = data.longitude || '';
          this.longitud = data.latitude || '';
          this.required_location = data.required_location;
          this.tableTime = data.table_time || 120;
          this.tpv_id = data.TPV_id;
          this.schedules = (data.schedules || []).map(schedule => ({
            inicio: schedule.start_hour || null,
            fin: schedule.final_hour || null,
            selectedDays: schedule.days ? schedule.days.split(', ').map(d => d.trim()) : []
          }));
          this.selectedTpvId = data.TPV_type_id || '';
          if (data.TPV_type === 'EasyPos') {
            this.organizationId  = data.organizationId?.toString()  || '';
            this.puntoVentaId    = data.puntoVentaId?.toString()    || '';
          }
          if (data.TPV_type === 'BDP') {
            this.login = data.login || '';
            this.password = data.password || '';
            this.integratorCode = data.integratorCode|| '';
            this.localUrl  = data.localUrl || '';
          }
          if (data.TPV_type === 'Revo') {
            this.revoToken = data.token || '';
            this.revoAccountUsername = data.account_username || '';
            this.revoClientToken = data.client_token || '';
          }
          if (data.TPV_type === 'LastApp') {
            this.lastappToken = data.token || '';
            this.lastappLocationId = data.location_id || '';
            this.lastappCatalogId = data.catalog_id || '';
            this.lastappBrandId = data.brand_id || '';
          }
          if (data.TPV_type === 'EposNow') {
            this.eposnowToken = data.token || '';
          }
          this.advanceMode = data.advance_mode || false;
          this.modes = (data.modes || []).map(mode => ({
            id: mode.id || uuidv4(),
            name: mode.name || '',
            discount: mode.discount || 0,
            platesMax: mode.plates_person || 0,
            excludedCategories: mode.excluded_categories || [],
            priceBlocks: (mode.initial_prices || []).map(price => ({
                adultPrice: price.adults_price || 0,
                childPrice: price.children_price || 0,
                horaInicio: price.schedule.start_hour || '00:00',
                horaFin: price.schedule.final_hour || '00:00',
                selectedDays: price.schedule.days ? price.schedule.days.split(', ') : []
            }))
        }));
        this.max_km_delivery = data.max_km_delivery || null;
        this.hasDelivery = !!this.max_km_delivery;
        this.user_allowed_to_cancel_order = data.user_allowed_to_cancel_order

        this.primary_color = data.customization?.primary_color || '#ff6600';
        this.secondary_color = data.customization?.secondary_color || '#333399';
        if(data.customization.logo){
          this.logoPreview = `${data.customization.logo}?t=${new Date().getTime()}`;
        }

        this.schedules = (data.schedules || []).map(schedule => ({
          inicio: schedule.start_hour || '',
          fin:    schedule.final_hour || '',
          selectedDays: schedule.days
            ? schedule.days.split(',').map(d => d.trim())
            : []
        }));

        // Si al mappear no viene ninguno, añadimos un único bloque vacío:
        if (this.schedules.length === 0) {
          this.schedules = [{
            inicio: '',
            fin:    '',
            selectedDays: []
          }];
        }

        if(this.first_charge){
          document.getElementById("spinner").classList.add("d-none")
          this.first_charge=false
        }

        } catch (error) {
          document.getElementById("spinner").classList.add("d-none")
          console.error('Error loading restaurant config:', error);
        }
      },
      async loadTpvsList() {
        try {
          const url = `${process.env.VUE_APP_API_URL}/v1/api/partner/get_tpvs_list`;
          return axios.get(url)
            .then(response => {
              this.tpvsList = response.data;
            })
            .catch(e => {
              console.error('Error cargando lista de TPVs:', e);
            });
        } catch (e) {
          console.error('Error cargando lista de TPVs:', e)
        }
      },
      updateAddress(newAddress, isCorrect, latitude, longitude) {
        this.address = newAddress;
        this.latitude = latitude;
        this.addressCorrect = isCorrect;
        this.longitude = longitude;
      },
      increaseTableTime() {
        this.tableTime += 5;
      },
      decreaseTableTime() {
        if (this.tableTime > 5) this.tableTime -= 5;
      },
      addSchedule() {
        this.schedules.push({ inicio: '', fin: '', selectedDays: []});
      },
      removeSechedule(index) {
        this.schedules.splice(index, 1);
        if (this.schedules.length === 0) {
          this.addSchedule();
        }
      },
      openModalNewMode() {
        this.showAddMode = true;
      },
      closeAddModeModal() {
        this.showAddMode = false;
      },
      addMode(mode) {
        const newMode = {
          ...mode,
          id: uuidv4()
        };
        this.modes.push(newMode);
        this.closeAddModeModal();
      },
      openEditModeModal(mode) {
        this.selectedMode = mode;
        this.editingMode = JSON.parse(JSON.stringify(mode));
        this.showEditMode = true;
      },
      closeEditModeModal() {
        this.showEditMode = false;
        this.selectedMode = null;
        this.editingMode = null;
      },
      updateMode(updatedMode) {
        const index = this.modes.findIndex(m => m.id === this.selectedMode.id);
        if (index !== -1) {
            this.modes.splice(index, 1, { ...this.selectedMode, ...updatedMode });
        }
        this.closeEditModeModal();
      },
      openDeleteModeModal(mode) {
        this.selectedMode = mode;
        this.showDeleteMode = true;
      },
      closeDeleteModeModal() {
        this.showDeleteMode = false;
      },
      deleteMode() {
        this.modes = this.modes.filter(m => m.id !== this.selectedMode.id);
        this.closeDeleteModeModal();
      },
      async saveRestaurantConfiguration() {
        if(!this.restaurantName) {this.errorMessage = "Debes indicar un nombre para el restaurante"; return;}

        const schedulesToValidate = this.schedules.slice(0, -1);
        const hasIncomplete = schedulesToValidate.some(s =>
          !(s.inicio && s.fin && s.selectedDays && s.selectedDays.length > 0)
        );
        if (hasIncomplete) {
          this.errorMessage = "Debes completar inicio, fin y días en todos los horarios (excepto el último en blanco).";
          return;
        }

        if (!this.hasDelivery) { this.max_km_delivery = null; }

        const url = process.env.VUE_APP_API_URL+'/v1/api/partner/update_restaurant_config';
        const configData = {
            name: this.restaurantName,
            address: this.address,
            // Ñapilla de coordenadas pq es un poco caos, no tocar, VA BIEN
            latitude: this.longitud,
            longitude: this.latitud,
            required_location: this.required_location,
            TPV_id: this.tpv_id,
            TPV_type_id: this.selectedTpvId,
            advance_mode: this.advanceMode,
            user_allowed_to_cancel_order: this.user_allowed_to_cancel_order,
            schedules: schedulesToValidate.map(schedule => ({
              start_hour: schedule.inicio,
              final_hour: schedule.fin,
              days: schedule.selectedDays.join(', ')
            })),
            modes: this.modes.map(mode => ({
                id: mode.id,
                name: mode.name,
                discount: mode.discount || 0,
                plates_person: mode.platesMax || 0,
                excluded_categories: mode.excludedCategories || [],
                initial_prices: mode.priceBlocks.map(block => ({
                    adults_price: block.adultPrice || 0,
                    children_price: block.childPrice || 0,
                    schedule: {
                        start_hour: block.horaInicio,
                        final_hour: block.horaFin,
                        days: block.selectedDays.join(", ") || ""
                    }
                }))
            })),
            max_km_delivery: this.max_km_delivery,
            ...(this.selectedTpvName === 'EasyPos' && {
              organizationId: this.organizationId,
              puntoVentaId: this.puntoVentaId
            }),
            ...(this.selectedTpvName === 'BDP' && {
              login: this.login,
              password: this.password,
              integratorCode: this.integratorCode,
              localUrl: this.localUrl
            }),
            ...(this.selectedTpvName === 'Revo' && {
              token: this.revoToken,
              account_username: this.revoAccountUsername,
              client_token: this.revoClientToken
            }),
            ...(this.selectedTpvName === 'LastApp' && {
              token: this.lastappToken,
              location_id: this.lastappLocationId,
              catalog_id: this.lastappCatalogId,
              brand_id: this.lastappBrandId
            }),
            ...(this.selectedTpvName === 'EposNow' && {
              token: this.eposnowToken
            }),
            primary_color: this.primary_color,
            secondary_color: this.secondary_color,
            logo: this.logoPreview ? this.logoPreview : ''
        };

        try {
          document.getElementById("spinner").classList.remove("d-none")
          await axios.put(url, configData, {
            headers: {
                'Authorization': `Bearer ${this.partner_token}`,
                'Content-Type': 'application/json'
            }
          });

          this.showConfirmation = true;
          
          setTimeout(() => {
            this.showConfirmation = false;
          }, 3000);

          this.errorMessage = '';
          document.getElementById("spinner").classList.add("d-none")

          this.$emit('ReviseSession');
        } catch (error) {
          this.showError = true
          console.error('Error al guardar la configuración del restaurante:', error);
          document.getElementById("spinner").classList.add("d-none")
          setTimeout(() => {
            this.showError = false;
          }, 3000);
        }
      },
      handleLogoUpload(event) {
        const file = event.target.files[0];
          if (!file) return;

          const reader = new FileReader();
          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              const targetWidth = 300;
              const targetHeight = 300;

              canvas.width = targetWidth;
              canvas.height = targetHeight;

              const scaleFactor = Math.min(targetWidth / img.width, targetHeight / img.height);
              const newWidth = img.width * scaleFactor;
              const newHeight = img.height * scaleFactor;

              const xOffset = (targetWidth - newWidth) / 2;
              const yOffset = (targetHeight - newHeight) / 2;

              ctx.drawImage(img, xOffset, yOffset, newWidth, newHeight);

              this.logoPreview = canvas.toDataURL("image/png");
            };
          };
        reader.readAsDataURL(file);
      },
      resetPrimaryColor() {
        this.primary_color = "#F47700";
      },
      removeLogo() {
        this.logoPreview = null;
      },
      toggleDelivery() {
        if (!this.hasDelivery) {
          this.max_km_delivery = null;
        }
      },
      TPV_confirmation() {
        if (!this.tpv_id && this.selectedTpvId) {
          this.showTpvModal = true;
        } else {
          this.saveRestaurantConfiguration();
        }
      },
      onTpvConfirm() {
        this.showTpvModal = false;
        this.saveRestaurantConfiguration();
      }
    },
    computed: {
      ...mapState(['partner_token']),
      selectedTpvName() {
        const sel = this.tpvsList.find(t => t.id === this.selectedTpvId);
        return sel ? sel.name : '';
      }
    },
    mounted() {
      this.loadTpvsList()
      .then(() => this.loadRestaurantConfig())
      .catch(err => console.error('Error cargando TPVs o config:', err));
    }
  };
</script>

<style scoped>
  .custom-slider {
    border-radius: 34px;
    width: 50px;
    height: 26px;
    position: relative;
  }

  .custom-slider:checked {
    background-color: #ff7a00;
  }

  .custom-radio:checked {
    background-color: #ff7a00;
  }

  #modes-list {
    white-space: nowrap;
    overflow-x: auto;
  }

  .custom-scroll::-webkit-scrollbar {
    height: 5px;
  }

  .custom-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(var(--primary-color-rgb), 0.68);
    border-radius: 10px;
  }

  #time-container {
    flex-direction: row;
  }

  .time-input {
    margin-bottom: 0;
    width: auto;
  }

  #time-container span {
    margin-bottom: 0;
  }

  .form-check-input:checked {
    background-color: var(--primary-color);
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 15px;
    }
  }
</style>